import {useSelector} from "react-redux";
import {financeSelector} from "../../../../../../redux/slices/financeSlice";
import {globalDataSelector} from "../../../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import s from './viewSubscriptionHistoryPopup.module.scss'
import SvgSelector from "../../../../../../components/SvgSelector/SvgSelector";
import CancelButton from "../../../../../../components/UiKit/Buttons/CancelBtn/CancelBtn";
import {convertDate} from "../../../../../../utils/helpers/formatTime";

const ViewSubscriptionHistoryPopup = ({active, setActive, subscription_history}) => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar} = useSelector(globalDataSelector);


    const {t} = useTranslation();


    useEffect(() => {
        if (topUpBalanceIsActive || exitPopup) {
            setActive(false);
        }
    }, [topUpBalanceIsActive, exitPopup]);

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                setActive(false);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };

        document.addEventListener("keydown", handleEscClose);

        return () => {
            document.removeEventListener("keydown", handleEscClose);
        };
    }, [setActive]);

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            setActive(false);
        }
    };

    return (
        <div
            className={`${s.popupWrapper} ${active ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleClosePopup}
        >
            <div
                className={active ? `${s.popup} ${s.active}` : s.popup}
            >
                <div className={s.header}>
                    <button
                        onClick={() => setActive(false)}
                        className={s.closePopup}
                        type="button"
                    >
                        <SvgSelector id="close-popup"/>
                    </button>
                    <div className={s.icon}>
                        <SvgSelector id="popup-info-icon"/>
                    </div>
                    <div className={s.popupInfo}>
                        <p className={s.title}>{t("subscription_history")}</p>
                    </div>
                </div>
                <div className={s.body}>
                    <ul className={s.subscriptionHistoryList}>
                        {
                            subscription_history?.map(({
                                                           subscription_name,
                                                           subscription_id,
                                                           start_date,
                                                           end_date
                                                       }, index) => (
                                <li key={subscription_id}>
                                    <span className={s.subscriptionName}>
                                        {index + 1}. {subscription_name}
                                    </span>
                                    <div className={s.subscriptionDates}>
                                        <span>
                                            {convertDate(start_date, 'DMY')}
                                        </span>
                                        -
                                        <span>
                                            {convertDate(end_date, 'DMY')}
                                        </span>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
                <div className={s.footerContainer}>
                    <CancelButton
                        text={t("close")}
                        action={() => setActive(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ViewSubscriptionHistoryPopup;